var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLegacyUrl)?_c('a',{attrs:{"href":_vm.legacyHref},on:{"click":function($event){return _vm.$showSpinner()}}},[_vm._t("default")],2):(!_vm.routePath)?_c('a',[_vm._t("default")],2):_c('router-link',{attrs:{"to":_vm.routePath}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }